window.isFlutterInAppWebViewReady = window.isFlutterInAppWebViewReady || false

class GoToProduct extends HTMLElement {
  constructor() {
    super();
  }
  goToProduct(productId, variantId) {
    console.log("GoToProduct ATC: productId", productId);
    console.log("GoToProduct ATC: variantId", variantId);
    
    const payload = {
        action: "openProduct",
        data: {
            productId: `gid://shopify/Product/${productId}`,
            variantId: `gid://shopify/ProductVariant/${variantId}`
        }
    };
    if(!window.isFlutterInAppWebViewReady){
      console.warn("Flutter not ready yet.")
      return 
    }
    window.flutter_inappwebview.callHandler('Stikky', payload);
  }
  
  connectedCallback() {
    const productId = this.getAttribute("product-id") || null;
    const variantId = this.getAttribute("variant-id") || null;
    if (!!productId && !!variantId) {
      this.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.goToProduct(Number(productId), Number(variantId));
      });
      return;
    }
  }
}

customElements.define("go-to-product", GoToProduct);
